<div class="container">
  <div class="admin-page-header">
    <h1 class="admin-page-title">{{'workermanager.title'|traduccion}}</h1>
    <div class="summary-chip">{{'workermanager.totalElements'|traduccion}}: {{ totalElements }}</div>
  </div>

  <mat-card class="table-card">
    <app-filter [filters]="fieldFilters" btLabel="Buscar" (submit)="submit($event)"></app-filter>
  </mat-card>

  <mat-card class="table-card">
    <ng-container [ngSwitch]="state">
      <div *ngSwitchCase="'idle'" class="placeholder">
        <mat-icon>search</mat-icon>
        <div [innerHTML]="'table.idle'|traduccion"></div>
      </div>

      <div *ngSwitchCase="'loading'" class="placeholder">
        <mat-progress-spinner mode="indeterminate" diameter="28"></mat-progress-spinner>
        <div>{{'table.loading'|traduccion}}</div>
      </div>

      <app-data-table
        *ngSwitchCase="'loaded'"
        [dataSource]="dataSource"
        [displayedColumns]="displayedColumns"
        [emptyMessage]="'table.nodata'|traduccion"
        [showPaginator]="true"
        [length]="totalElements"
        [pageSize]="pageSize"
        [pageIndex]="pageIndex"
        [pageSizeOptions]="[10, 25, 50]"
        [rowClickable]="true"
        (rowClick)="setOpen($event.row)"
        (page)="onPageChange($event)">

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>{{'workermanager.table.header.status'|traduccion}}</th>
          <td mat-cell *matCellDef="let element">
            <span [class]="statusClass(element.status)">{{ formatEnumLabel(element.status) }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef>Worker</th>
          <td mat-cell *matCellDef="let element">
            <div class="worker-cell">
              <strong>#{{ element.id }}</strong>
              <span>{{ formatEnumLabel(element.type) }}</span>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="payload">
          <th mat-header-cell *matHeaderCellDef>{{'workermanager.table.header.payload'|traduccion}}</th>
          <td mat-cell *matCellDef="let element">
            <div class="payload-cell">
              <code>{{ payloadPreview(element.payload) }}</code>
              <span class="muted-inline">Tag: {{ valueOrDash(element.tag) }}</span>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="aggregateVersion">
          <th mat-header-cell *matHeaderCellDef>{{'workermanager.table.header.aggregateVersion'|traduccion}}</th>
          <td mat-cell *matCellDef="let element">{{ valueOrDash(element.version) }}</td>
        </ng-container>

        <ng-container matColumnDef="attempts">
          <th mat-header-cell *matHeaderCellDef>Intentos</th>
          <td mat-cell *matCellDef="let element">
            <div class="attempts-cell">
              <strong>{{ element.currentAttempts }}/{{ element.maxAttempts }}</strong>
              <span class="muted-inline">P{{ element.priority }} · {{ element.periodic ? 'Periódico' : 'Una vez' }}</span>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="nextRun">
          <th mat-header-cell *matHeaderCellDef>{{'workermanager.table.header.nextRun'|traduccion}}</th>
          <td mat-cell *matCellDef="let element">{{ formatDateTime(element.nextRun) }}</td>
        </ng-container>

        <ng-container matColumnDef="createdAt">
          <th mat-header-cell *matHeaderCellDef>{{'workermanager.table.header.createdAt'|traduccion}}</th>
          <td mat-cell *matCellDef="let element">{{ formatDateTime(element.createdAt) }}</td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row" class="text-right">
            <button mat-flat-button class="cancel-btn" (click)="reset(row); $event.stopPropagation()">{{'workermanager.table.header.action'|traduccion}}</button>
          </td>
        </ng-container>
      </app-data-table>

      <div *ngSwitchCase="'error'" class="placeholder error">
        <mat-icon>error_outline</mat-icon>
        <div>{{'finance.payment.table.error'|traduccion}} <button mat-button color="primary" (click)="searchWorkerManager()">{{'finance.payment.table.retry'|traduccion}}</button></div>
      </div>
    </ng-container>
  </mat-card>
</div>
